"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.XIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var Icon_1 = require("../../internal/Icon");
var XIcon16Light_1 = require("./XIcon16Light");
var XIcon16Regular_1 = require("./XIcon16Regular");
var XIcon16Solid_1 = require("./XIcon16Solid");
var XIcon20Light_1 = require("./XIcon20Light");
var XIcon20Regular_1 = require("./XIcon20Regular");
var XIcon20Solid_1 = require("./XIcon20Solid");
var XIcon24Regular_1 = require("./XIcon24Regular");
var XIcon24Solid_1 = require("./XIcon24Solid");
var XIcon32Regular_1 = require("./XIcon32Regular");
var XIcon64Regular_1 = require("./XIcon64Regular");
var sizes = {
    16: {
        light: XIcon16Light_1.XIcon16Light,
        regular: XIcon16Regular_1.XIcon16Regular,
        solid: XIcon16Solid_1.XIcon16Solid,
    },
    20: {
        light: XIcon20Light_1.XIcon20Light,
        regular: XIcon20Regular_1.XIcon20Regular,
        solid: XIcon20Solid_1.XIcon20Solid,
    },
    24: {
        regular: XIcon24Regular_1.XIcon24Regular,
        solid: XIcon24Solid_1.XIcon24Solid,
    },
    32: {
        regular: XIcon32Regular_1.XIcon32Regular,
    },
    64: {
        regular: XIcon64Regular_1.XIcon64Regular,
    },
};
exports.XIcon = forwardRef_1.forwardRef('XIcon', function (props, ref) {
    return react_1.default.createElement(Icon_1.Icon, tslib_1.__assign({ ref: ref }, props, { sizes: sizes }));
});
